import http from "../http-common";

const productCreate = data => {
  
  //전송할 데이터에 파일이 있을경우
  const config = {
    headers : {
        'context-type' : 'multipart/form-data'
    }
  }

  return http.post("payment/product", data, config);
};

const productGetAll = () => {
  return http.get("payment/product");
};

const productDelete = data => {
  return http.delete("payment/product", {data : {prd_idx : data}});
};

const productModify = data => {

  //전송할 데이터에 파일이 있을경우
  const config = {
    headers : {
        'context-type' : 'multipart/form-data'
    }
  }

  return http.put("payment/product", data, config);
};

const productSelect = data => {
  return http.get(`payment/product/${data}`);
};

const ProductService = {
  productCreate,
  productGetAll,
  productDelete,
  productModify,
  productSelect,
};

export default ProductService;
